import axios from "axios";

const VenueService = {

    getAll: async function (filters) {
        try {
            const response = await axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/venues?'+filters)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                venues: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    getOne: async function (venueId) {
        try {
            const response = await axios.get(process.env.VUE_APP_SERVER_URL + `/api/v1/venues/${venueId}`)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                venue: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    create: async function (params) {
        try {
            const response = await axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/venues/', params)
            return response.data.data;
        } catch (e) {
            console.log(e);
            return {
                venue: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    update: async function (venueId, params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/venues/' + venueId, params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                venue: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    updateConfig: async function (optionId, params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/venues/configs/' + optionId, params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                option: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    deletePage: async function (venueId) {
        if (confirm("Are you sure you want to delete this venue?.")) {
            try {
                const response = await axios.delete(process.env.VUE_APP_SERVER_URL + `/api/v1/venues/${venueId}`)
                return response.data.data.message
            } catch (e) {
                console.log(e.message);
                return {
                    venue: null,
                    error: e,
                    message: "An error occurred while connecting to server"
                }
            }
        }
    },

};

export default VenueService;